const NotificationAlert = () => {
    const isExpired = new Date() > new Date('2025-12-31');

    if (isExpired) return null;
    
	return (
		<div
			style={{
				background: '#30e700',
				margin: '0px',
			}}
		>
			<p style={{ width: '85%',margin: 'auto', textAlign: 'center', fontWeight: 'normal', padding: '10px' }}>
				Points earned before October 25' <span style={{color: 'red'}}>expire on 31 Dec 2025 </span>
                     — redeem now.
			</p>
		</div>
	);
};

export default NotificationAlert;
